import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UploadFile} from '../../models/upload-file';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {
  upload(file: File): Observable<UploadFile> {
    return new Observable<UploadFile>((subscriber) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        const uploadFile = new UploadFile();
        uploadFile.filename = file.name;
        uploadFile.data = String(fileReader.result);

        subscriber.next(uploadFile);
      };

      fileReader.onerror = (error) => {
        subscriber.error(error);
      };
    });
  }
}
